import moment from 'moment';
import { history } from './'

export const userStatus = () => {
  let signinStatus = JSON.parse(sessionStorage.getItem('cellit_userdata'));

  if ( !signinStatus ) return false;

  let expire_date = moment(signinStatus.expire_date).valueOf();
  let date = moment().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
  let today = moment(date).valueOf();

  if ( today < expire_date ) return signinStatus;

  sessionStorage.removeItem('cellit_userdata');
  history.push('/signin');

  return false;
}